import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

export interface DevPreview {
  id: string;
  label: string;
  description: string;
  Component: LazyExoticComponent<ComponentType>;
}

/**
 * Registry of dev-only UI previews rendered by the /dev playground route.
 */
export const devPreviews: DevPreview[] = [
  {
    id: 'sso-account-link',
    label: 'SSO account linking',
    description: 'OTP → SSO cutover: link existing account or create new',
    Component: lazy(() => import('./SsoAccountLinkPreview')),
  },
];
